import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Alert, Input, Col } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

import logo from './img/logo.png'

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate, changeDefaultLocale } = useLocalization();
  changeDefaultLocale('pt-BR');
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const parameters = queryString.parse(location.search);

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    const encodedPassword = encodeURIComponent(password);

    api.userPassLogin(
      {
        username,
        password: encodedPassword,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);
        let message = translate("RequestLoginErrorMessage")
        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div className="login-nipbr-container text-align-center" ref={nodeRef}>
        <div className="login-nipbr-header" style={{ marginBottom: '20px' }}>
          <img src={logo} alt="logo" className="logo-nipbr rounded d-block" />
        </div>

        <div className="welcome-text-nipbr">
          <h3>{translate("WelcomeTitle")}</h3>
          <p className="lead">
            <small>{translate("WelcomeSubtitle")}</small>
          </p>
        </div>

        <div className="login-nipbr-body">
          <Form onSubmit={event => onSubmit(event)}>
            <div className="messages-container">
              <Alert color="danger" id="error-message" isOpen={error.open} toggle={() => setError({ open: false })}>
                {error.message}
              </Alert>
            </div>

            <Col style={{ padding: '0px', textAlign: 'left' }}>
              <Input
                className="input-nipbr"
                disabled={onLogin}
                required={true}
                tabIndex={1}
                type="text"
                autoCorrect="off"
                autoCapitalize="none"
                id="username"
                placeholder={translate("PlaceholderUserName")}
                onChange={e => setUsername(e.target.value)}
              />
            </Col>

            <Col style={{ padding: '0px', textAlign: 'left' }}>
              <div className="password-group-nipbr">
                <Input
                  className="input-nipbr"
                  required={true}
                  disabled={onLogin}
                  tabIndex={1}
                  type={showPassword ? "text" : "password"}
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="password"
                  placeholder={translate("PlaceholderPassword")}
                  onChange={e => setPassword(e.target.value)}
                />
                <span
                  className="toggle-password"
                  onClick={togglePasswordVisibility}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      togglePasswordVisibility();
                    }
                  }}
                >
                  <i className={!showPassword ? "fa fa-eye-slash" : "fa fa-eye"}></i>
                </span>
              </div>
            </Col>

            {!onLogin ?
              <div className="row nipbr-btns-row">
                <div className="col-xs-12 col-md-12 col-lg-12">
                  <div>
                    <button
                      block={!parameters.failureRedirect}
                      tabIndex={1}
                      className="enter-nipbr"
                      type="submit"
                      name="submit"
                      disabled={!props.turnstileSuccess}
                    >
                      {translate("ButtonEnter")}
                    </button>
                  </div>
                </div>
              </div>
              :
              <Progress animated color="danger" value={100} />
            }

            {/* <div className="forgotnipbrText">
              <a href="https://cliente.nipbr.net.br/recuperar_senha/adicionar">{translate("ForgotPassword")}</a>
            </div> */}
          </Form>
        </div>
        <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
      </div>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm, { useInsideForm: true, style: { marginTop: '2rem' } });
